export type int = {}
export type float = { x: number }
export type vec2 = { x: number, y: number }
export type vec3 = { x: number, y: number, z: number }
export type vec4 = { x: number, y: number, z: number, w: number }
export type ivec2 = {}
export type ivec3 = {}
export type ivec4 = {}
export type uvec2 = {}
export type uvec3 = {}
export type uvec4 = {}
export type mat2 = {}
export type mat3 = {}
export type mat4 = {}
export type sampler2D = {}
export type samplerCube = {}

